export default __webpack_public_path__ + "static/media/4ecad89c18b9d63eafb38a854506f80a.jpg";